import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { TimeoutError } from 'rxjs';
import { ErrorsService } from '../../../shared/services/errors.service';


@Component({
    selector: 'hs-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

    public form: FormGroup;
    submitted = false;
    success = false;
    username = '';
    loading = false;

    error = false;
    errorMessage: string;
    timeoutError = false;

    constructor(
      private formBuilder: FormBuilder,
      private auth: AuthService,
      private errorsService: ErrorsService
    ) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            user: ['', Validators.required],
        });
    }

    get f() {
        return this.form.controls;
    }

    forgotPassword() {
        this.submitted = true;
        if (this.form.invalid) {
            return;
        }
        this.loading = true;
        this.form.disable();

        this.auth.getNewPassword(this.form.value.user).subscribe(response => {
            this.success = true;
            this.submitted = false;
            this.form.enable();
            this.loading = false;
        }, error => {

            if (error instanceof TimeoutError) {
                this.timeoutError = true;
            } else {
                this.error = true;
                this.errorMessage = error?.error?.message;
            }
            this.submitted = false;
            this.form.reset();
            this.form.enable();
            this.loading = false;

            this.errorsService.track(error);
        });
    }


}
